module.exports = __webpack_public_path__ + "img/verawang.9d0989dc.jpg";